module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-6-45ba3edec01d42248de35e063aa35fca.svg";